<template>
    <Head title="Confirm Password" />

    <div class="mb-4 text-sm text-gray-600">
        This is a secure area of the application. Please confirm your password before continuing.
    </div>

    <BreezeValidationErrors class="mb-4" />

    <form @submit.prevent="submit">
        <div>
            <BreezeLabel for="password" value="Password" />
            <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password" autofocus />
        </div>

        <div class="flex justify-end mt-4">
            <BreezeButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Confirm
            </BreezeButton>
        </div>
    </form>
</template>

<script>
import { defineAsyncComponent } from "vue";
import BreezeGuestLayout from '@/Layouts/Guest.vue'

export default {
    layout: BreezeGuestLayout,

    components: {
        BreezeButton: defineAsyncComponent(() => import('@/Components/Button.vue')),
        BreezeInput: defineAsyncComponent(() => import('@/Components/Input.vue')),
        BreezeLabel: defineAsyncComponent(() => import('@/Components/Label.vue')),
        BreezeValidationErrors: defineAsyncComponent(() => import('@/Components/ValidationErrors.vue')),
        Head: defineAsyncComponent(() => import('@inertiajs/vue3')),
    },

    setup() {
        const form = useForm({
            password: '',
        });

        const submit = () => {
            form.post(this.route('password.confirm'), {
                onFinish: () => this.form.reset(),
            })
        };

        return {
            form,
            submit,
        };
    },
}
</script>
